import { useQuery } from "@tanstack/react-query";
import { getCkycFlows } from "../OrderService";
import { CKYC_FLOWS_QUERY_KEY } from "../OrderConstants";

/**
 * TanStack React Query Hook for GET /ckyc/flows
 * Returns { upload_doc_enabled, verify_enabled } - which CKYC journeys the backend has switched on.
 */
export const useCkycFlows = (options = {}) => {
  return useQuery({
    queryKey: CKYC_FLOWS_QUERY_KEY,
    queryFn: async () => {
      const response = await getCkycFlows();
      return response?.data || {};
    },
    ...options,
  });
};

export default useCkycFlows;
